<template>
  <div
    v-loading="loading"
    :class="b()"
    :style="{
      zIndex: zIndex
    }"
  >
    <div :class="b('top')">
      <div :class="b('title')">
        <span>{{ $t('guide.task.title') }}<em :class="['zkicon','iconxingxing', b('star')]"></em> </span>
        <el-button
          type="text"
          :class="b('close')"
          icon="zkicon icontanchuangshouqi"
          is-icon
          @click="$emit('closed')"
        ></el-button>
      </div>
      <div
        v-if="isOver"
        :class="b('finish')"
      >
        {{ $t('guide.task.finish') }}
      </div>
      <div v-else>
        <div
          :class="b('info')"
          v-html="tip"
        ></div>
        <div :class="b('container')">
          <div
            v-for="(square, index) of userQuestList"
            :key="square.id"
            :class="b('square', {done: index < doneList.length})"
          ></div>
        </div>
      </div>
    </div>
    <div
      ref="mainRef"
      :class="b('main')"
    >
      <menu-item
        v-for="(item, index) of userQuestList"
        ref="menuItemRef"
        :key="item.id"
        :task="item"
        :integrate-status-map="integrateStatusMap"
        :finish-num="finishNum"
        :index="index"
        :get-default-project="getDefaultProject"
        :current-project-is-personal="currentProjectIsPersonal"
        @createBoard="createBoard"
        @action="action"
      ></menu-item>
    </div>
    <div :class="b('footer')">
      <span @click="closeGuide">{{ $t('guide.new.closeGuide') }}</span>
    </div>
    <el-dialog
      :title="$t('guide.new.closeGuideTitle')"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="500px"
      :close-on-click-modal="false"
    >
      <div :class="b('closeTip')">
        {{ $t('guide.new.closeGuideContent') }}
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">{{ $t('guide.new.closeGuideCancel') }}</el-button>
        <el-button
          type="primary"
          @click="handleClose"
        >{{ $t('guide.new.closeGuideConfirm') }}</el-button>
      </span>
    </el-dialog>
    <BuildDashboard
      ref="buildDashboardRef"
      :do-add="doAdd"
    ></BuildDashboard>
  </div>
</template>

<script>
import theme from '@zk/theme/lib/variables.scss';
import menuItem from './menuItem';
import BuildDashboard from '@/components/GridDashboard/CreatePanelDialog/BuildDashboard.vue';
import {
  sysHomeTemplateGetTemplate
} from '@/api/home';
import { useProjectGetLatelyHandleSprint } from '@/components/GridDashboard/util';
import { mapState, mapGetters } from 'vuex';
// eslint-disable-next-line
import { syshomeFromconfigAdd, listDashboard } from '@/api/home';
import { getCopyName } from '@zk/framework-vue';
import { guideRecord, guideUpdateStatus } from '@/api/guide';
import { PopupManager } from 'zk-ui';
export default {
  name:'LightMenu',
  bemNS: theme.bemNS,
  components: {
    menuItem,
    BuildDashboard
  },
  props:{
    lightsData:{
      type:Object,
      default:()=>({})
    },
    show: {
      type:Boolean,
      default: false
    }
  },
  data(){
    return {
      loading: false,
      dialogVisible: false,
      done: null,
      zIndex: PopupManager.nextZIndex()
    };
  },
  computed:{
    ...mapState('app', ['projectList']),
    ...mapState('user', ['account']),
    ...mapGetters('app', ['currentProject']),
    isEn(){
      return this.$i18n.locale !== 'zh';
    },
    integrateStatusMap(){
      return this.lightsData.integrateStatusMap || {};
    },
    userQuestList(){
      return this.lightsData.userQuestList || [];
    },
    isOver(){
      return this.userQuestList.length === this.doneList.length;
    },
    doneList(){
      return this.userQuestList.filter(item => item.questStatus);
    },
    finishQuestList(){
      return this.userQuestList.filter(i => i.questStatus);
    },
    finishNum(){
      return this.finishQuestList.length;
    },
    isPersonalProject(){
      return this.projectList.find(i => i.projectType === 'PERSONAL_PROJECT' && i.createBy === this.account.userId);
    },
    // 当前项目是否为个人项目
    currentProjectIsPersonal(){
      const project = this.isPersonalProject;
      console.log('--currentProjectIsPersonal----', project, this.currentProject);
      return project?.id === this.currentProject?.id;
    },
    tip(){
      const count = this.userQuestList.length - this.finishNum;
      return this.$t('guide.task.taskInfo', [`<span style="font-weight:600;"> ${count} </span>`]);
    }
  },
  watch: {
    show(val){
      if (val) {
        this.zIndex = PopupManager.nextZIndex();
      }
    }
  },
  created(){
    this.list = this.lightsData;
  },
  mounted(){
    this.eventBus.$on('finish-guide-task', this.finishGuideTask);
    this.handleContinueCreateBoard();
  },
  beforeDestroy(){
    this.eventBus.$off('finish-guide-task', this.finishGuideTask);
  },
  methods:{
    action(fn){
      this.done = fn;
    },
    finishGuideTask(questCode){
      const task = this.userQuestList.find(item=>item.questCode === questCode);
      if (task){
        if (!task.questStatus){
          guideUpdateStatus(task.id, 10);
        }
        task.questStatus = 10;
      }
    },
    closeGuide(){
      if (this.isOver) {
        this.handleClose();
        return;
      }
      this.dialogVisible = true;
    },
    finishTaskTrack(){
      const finish_num = this.finishNum;
      const finish_scene_num = this.finishQuestList.filter(i => i.questGroup === 'target').length;
      this.$track.send('UG_FinishTask', { finish_num, total_num: this.userQuestList.length, finish_scene_num: finish_scene_num }, true);
    },
    async handleClose(){
      await guideRecord(26);
      this.$store.dispatch('guide/queryGuideInfo', true);
      this.dialogVisible = false;
      this.eventBus.$emit('close-guide-bulb');
      this.finishTaskTrack();
    },
    getDefaultProject(){
      return this.$store.getters['app/getCurrentOrDefaultProjectId'];
    },
    async getDefaultSprint(project){
      const { recentSprint, sprintList } = await useProjectGetLatelyHandleSprint(project);
      return recentSprint?.id || sprintList?.[0]?.id;
    },
    async getBoardTemplateData(id){
      const project = this.getDefaultProject();
      const sprint = await this.getDefaultSprint(project);
      return sysHomeTemplateGetTemplate({
        id: id,
        projectId: project,
        sprintIds: sprint ? [sprint] : null
      });
    },
    async createBoard(templateId){
      this.loading = true;
      const template = await this.getBoardTemplateData(templateId);
      await this.$refs.buildDashboardRef?.useTemplateAddPanel(template);
    },
    async getAllDashBoardList(){
      const res = await listDashboard();
      const collapseDashboardList = (res?.spaceList?.[0]?.list || []).map(item => ({
        ...item,
        isEdit: false
      }));
      const dashboardList = (res?.list || []).map(item => ({
        ...item,
        isEdit: false
      }));
      return [...dashboardList, ...collapseDashboardList];
    },
    getHomePageInfo(allDashboardList){
      // const defaultName = this.$t('home.newer');
      const defaultName = this.$t('home.newDashboard');
      const newName = allDashboardList.some(d => d.name === this.$t('home.newDashboard')) ?
        getCopyName(defaultName, allDashboardList.map(d => d.name), '')
        : this.$t('home.newDashboard');
      return { name: newName, type: 'personal' };
    },
    async doAdd(widgets){
      const allDashboardList = await this.getAllDashBoardList();
      const homePage = this.getHomePageInfo(allDashboardList);
      // eslint-disable-next-line
      const res = await syshomeFromconfigAdd({ homePage, widgets });
      if (this.$route.name === 'dashboard') {
        this.eventBus.$emit('home:reload');
      }
      // window.localStorage.setItem(this.$store.state.app.HOME_DASHBOARD_KEY, String(res.id));
      await this.$store.dispatch('user/saveDashboard', res.id);
      this.loading = false;
      this.done?.('createDashboard');
      this.done = null;

      // if (this.$route.name !== 'dashboard') {
      //   this.$router.push('/dashboard');
      // } else {
      //   this.eventBus.$emit('home:reload');
      // }
    },
    handleContinueCreateBoard() {
      const { templateId, action } = this.$route.query;
      if (templateId && action === 'createBoard') {
        this.createBoard(templateId);
      }
    }

  }
};
</script>

<style lang="scss" scoped>
@include b(light-menu) {
  width: 290px;
  // height: 431px;
  position: absolute;
  overflow-x: hidden;
  bottom: 54px;
  background-color: white;
  // z-index: 2005;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.1);
  border-radius: 9px;
  @include e(top){
    // height: 105px;
    padding: 20px 16px;
    background-color: var(--primary-color);
    color: white;
    @include e(title){
      font-size: 20px;
      font-weight: 600;
      color: #fff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      @include e(close){
       ::v-deep{
        .icontanchuangshouqi{
            font-size: 20px;
            color: #fff !important;
          }
       }
      }
      @include e(star){
        color: rgba(250, 185, 7, 1);
        font-size: 24px;
        margin-left: 2px;
      }

    }
    @include e(info){
      font-size: 12px;
      line-height: 17px;
      margin-bottom: 10px;
      opacity: 0.8;
    }
    @include e(container){
      display: flex;
      height: 6px;
      @include e(square){
        height: 6px;
        flex: 1;
        opacity: 0.4;
        background:white ;
        @include m(done){
          opacity: 1;
        }
        margin-left: 2px;
        &:first-child{
          margin-left: 0;
          border-top-left-radius: 80px;
          border-bottom-left-radius: 80px;
          }
        &:last-child{
           border-top-right-radius: 80px;
           border-bottom-right-radius: 80px;
         }
      }
    }
    @include e(finish){
      font-size: 12px;
      margin-top: 16px;
      line-height: 21px;
      font-weight: var(--weight-font-Semiblod);
    }
  }
  @include e(main){
    overflow-y: auto;
    // height: 288px;
    max-height: calc(100vh - 255px);
    min-height: 168px;
    padding-top: 8px;
    width: 100%;
    overflow-x: hidden;
  }
  @include e(footer){
    height: 49px;
    text-align: right;
    color: rgba(121, 122, 133, 1);
    padding-right: 16px;
    line-height: 49px;
    span{
      cursor: pointer;
    }
  }
  @include e(menu-item){
    width: 300px;
    border-radius: 6px;
    margin:0px 20px;
    margin-bottom: 12px;
    padding: 0px 16px;
    background: #F9FAFC;
    @include e(detail){
      padding-bottom: 10px;
      text-align: center;
      width:100%;
      // height: 178px;
      img{
        // width: 112px;
        height: 100px;
        // margin-bottom: 10px;
        // padding: 7px 0px;
      }
      @include e(desc){
        text-align: left;
        margin-top: 10px;
      }
      @include e(option) {
        display: flex;
        margin-top: 10px;
        // height: 28px;
        // line-height: 28px;
        ::v-deep {
          .el-button{
            height: 28px;
            padding: 0px 12px;
            min-width: 48px;
            border-radius: var(--radius-mini);
          }
        }
        @include e(try){
          &+.zk-light-menu__look{
            margin-left: 12px;
          }
        }
      }
    }
    @include m(en) {
      @include e(detail) {
        height: auto;
        padding-bottom: 10px;
        @include e(option) {
          margin-top: 8px;
          .zk-light-menu__look {
            margin-top: 4px;
            margin-bottom: 2px;
          }
          @include e(try){
            &+.zk-light-menu__look{
              margin-left: 10px;
              margin-top: 0px;
              margin-bottom: 0px;
            }
          }
        }
      }
      @include e(desc){
        line-height: 20px;
      }
    }
  }
  @include e(closeTip){
    min-height: 40px;
  }
  @include e(head) {
    width: 100%;
    height: 46px;
    line-height: 46px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .left {
      display: flex;
      align-items: center;

      .icon {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
      .zk-symbol-icon{
        margin-left: 8px;
      }
    }
    img {
      width: 28px;
      height: 27px;
      vertical-align: middle;
    }
    @include e(text){
      margin-left: 10px;
    }
    @include e(state-done){
      background-color: var(--state-done-disable);
      width: 20px;
      height: 20px;
      margin-right: 4px;
      margin-left: 4px;
      border-radius: 50%;
      justify-content: center;
      display: flex;
      align-items: center;
      .icongou1{
        color: white;
        font-size: 20px;
      }
    }
    @include e(icon-direct){
      float: right;
    }
  }
}
</style>
<style lang="scss">
.driver-fix-index .zk-light-menu{
  display: none;
}
.driver-fix-index .RightContent_wrapper_Ecgdc{
  position: absolute;
}
</style>
